import React from "react";
import Translate, { Message } from "../messages/GeralMessages";

export default function DeliveryHelper() {

    function Status(i, justName) {
        const res = StatusList.filter(x => x.value == i);
        if (res.length == 0) {
            return "S.I."
        } else {
            if (justName) {
                return res[0].name;
            } else {
                return <span className={`badge badge-${res[0].color}`}>{res[0].name}</span>
            }
        }
    }

    function Weigth(delivery) {
        let totalWeight = 0;
        if (delivery.boxes) {
            for (let s in delivery.boxes) {
                totalWeight += delivery.boxes[s].weight;
            }
        }
        return totalWeight;
    }

    const Type = {
        Express: 0,
        Formal: 1,
    }

    const StatusObj = {
        Configuring: 0,
        Processing: 1,
        Ongoing: 2,
        Error: 3,
        Canceled: 4,
        Returning: 5,
        Returned: 6,
        Delivered: 7,
    }
    const StatusList = [
        { name: Translate(Message.Status.Configuring), slug: "Configuring", value: 0, color: "secondary" },
        { name: Translate(Message.Status.Processing), slug: "Processing", value: 1, color: "primary" },
        { name: Translate(Message.Status.Ongoing), slug: "Ongoing", value: 2, color: "ongoing" },
        { name: Translate(Message.Status.Error), slug: "Error", value: 3, color: "warning" },
        { name: Translate(Message.Status.Canceled), slug: "Canceled", value: 4, color: "danger" },
        { name: Translate(Message.Status.Returning), slug: "Returning", value: 5, color: "warning" },
        { name: Translate(Message.Status.Returned), slug: "Returned", value: 6, color: "success" },
        { name: Translate(Message.Status.Delivered), slug: "Delivered", value: 7, color: "success" },
    ]

    const CancelationMotives = [
        { code: "001", description: Translate(Message.PackageNotReady) },
        { code: "002", description: Translate(Message.RatesTooHigh) },
        { code: "003", description: Translate(Message.TransitTimeTooSlow) },
        { code: "004", description: Translate(Message.TakeToServiceCenterOrDropBox) },
        { code: "005", description: Translate(Message.CommitmentTimeNotMet) },
        { code: "006", description: Translate(Message.ReasonNotGiven) },
        { code: "007", description: Translate(Message.Other) },
        { code: "008", description: Translate(Message.PickupModified) }
    ]

    function TotalDeclaredValue(delivery) {
        let total = 0;
        for (let s in delivery.boxes) {
            total += delivery.boxes[s].price;
        }

        return total;
    }

    function TotalDeclaredItems(delivery) {
        let count = 0;
        for (let s in delivery.boxes) {
            if (delivery.boxes[s].items.length == 0) {
                count++;
            } else {
                count += delivery.boxes[s].items.length;
            }
        }

        return count;
    }

    function TotalDeclaredWeight(delivery) {
        let weight = 0;
        for (let s in delivery.boxes) {
            weight += delivery.boxes[s].weight;
        }

        return weight;
    }

    function IsNational(delivery, country) {
        let res = false;
        if (delivery.origin != undefined) {
            if (delivery.origin.country == country && delivery.destination.country == country) {
                res = true;
            }
        }

        return res;
    }

    function GetName(newNames, name) {
        let exist = newNames.filter(x => x.oldName == name);
        if (exist.length > 0) {
            return exist[0].name
        } else {
            return name;
        }
    }

    const DeliveryPurpose = [
        { value: "SOLD", name: "Comercial" },
        { value: "GIFT", name: "Brinde" },
        { value: "SAMPLE", name: "Amostra" },
        { value: "REPAIR_AND_RETURN", name: "Conserto e devolução" },
        { value: "PERSONAL_EFFECTS", name: "Efeitos pessoais" },
        { value: "NOT_SOLD", name: "Uso pessoal" },
    ]

    return {
        Status,
        StatusObj,
        TotalDeclaredValue,
        TotalDeclaredItems,
        TotalDeclaredWeight,
        IsNational,
        CancelationMotives,
        GetName,
        Type,
        Weigth,
        DeliveryPurpose,
    }
}